
export const GET_PRICING = '/iam/billing/stripe/pricingDetails';
export const GET_BILLING_INFO = '/iam/billing/stripe/getBillingInfo'
export const GET_PLAN_GUIDE_STEPS = 'iam/billing/stripe/planGuide/steps'
export const FETCH_PLAN = '/iam/billing/stripe/planGuide'